/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

const ChatButtonSkeleton = _ref => {
  let {
    className,
    size,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const skeletonClasses = cx(className, `${prefix}--skeleton`, `${prefix}--btn`, `${prefix}--chat-btn`, {
    [`${prefix}--layout--size-${size}`]: size
  });
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: skeletonClasses
  }, rest));
};
ChatButtonSkeleton.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string,
  /**
   * Specify the size of the `ChatButtonSkeleton`, from the following list of sizes:
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

export { ChatButtonSkeleton as default };
